import { render, staticRenderFns } from "./OTPInput.vue?vue&type=template&id=6d0a3c25&scoped=true&"
import script from "./OTPInput.vue?vue&type=script&lang=js&"
export * from "./OTPInput.vue?vue&type=script&lang=js&"
import style0 from "./OTPInput.vue?vue&type=style&index=0&id=6d0a3c25&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0a3c25",
  null
  
)

export default component.exports